import { useState } from 'react';

const faqItems = [
  {
    id: 1,
    question: '极速影视是否需要注册或付费？',
    answer: '极速影视完全免费，无需注册即可在线观看所有高清影片。我们致力于为影迷提供零门槛的观影体验，不设置任何付费墙或会员限制，打开网站就能畅享海量高清大片。',
  },
  {
    id: 2,
    question: '为什么极速影视的播放速度这么快？',
    answer: '极速影视采用先进的视频CDN分发技术，在全国部署多个加速节点，确保无论你身在何处都能获得最近的服务器响应。同时我们对视频编码进行了专项优化，在保证高清画质的前提下最大程度压缩数据体积，实现真正的秒开不缓冲。',
  },
  {
    id: 3,
    question: '影片资源多久更新一次？',
    answer: '极速影视每日同步更新最新院线资源和热门影片。我们的内容团队全天候监测各大影视平台的更新动态，确保第一时间上线新片。通常院线下映的影片在7-15天内即可在极速影视观看高清版本。',
  },
  {
    id: 4,
    question: '支持哪些设备观看？画质如何？',
    answer: '极速影视全面适配电脑、平板和手机端，无需下载APP，使用浏览器即可流畅观影。所有影片均提供1080P及以上高清画质，部分热门大片支持4K超清。我们建议使用Chrome、Safari或Edge等现代浏览器以获得最佳观影体验。',
  },
];

export default function FAQSection() {
  const [openIds, setOpenIds] = useState<number[]>([1, 2, 3, 4]);

  const toggleFaq = (id: number) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <section id="faq" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于极速影视，你可能想了解的一切</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = openIds.includes(item.id);
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(item.id)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                >
                  <h3 className="text-sm font-semibold text-foreground-900 pr-4">{item.question}</h3>
                  <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                {isOpen && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}